import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=e237f6fa&scoped=true&"
import script from "./LogoutButton.vue?vue&type=script&lang=ts&"
export * from "./LogoutButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e237f6fa",
  null
  
)

export default component.exports